module.exports = __webpack_public_path__ + "img/image-thumb-12.011471f7.webp";